import React from "react";

import Olx from "../../Images/olx.png";
import Hubspot from "../../Images/hubspot.png";
import Chargebee from "../../Images/chargebee.png";
import Ketto from "../../Images/ketto.png";

import { Button } from "../ButtonElement"

import { 
    ArrowForward,
   } from "../HeroSection/HeroElements"
import {
    ServicesContainer,
    ServicesCard,
    ServicesH1,
    ServicesH2,
    ServicesIcon,
    ServicesP,
    ServicesWrapper,
    BtnWrap,
    TechUsed
} from './ServicesElements'
const Services = () => {

    return <ServicesContainer id = "services">
        <ServicesH1>Projects</ServicesH1>
        <ServicesWrapper>
            <ServicesCard>
                <ServicesIcon src = {Olx} alt = "Olx" />
                <ServicesH2>
                    OLX Web App Clone
                </ServicesH2>
                <ServicesP>
                OLX the abbreviated form of OnLine eXchange is an online marketplace company for 
                buying and selling services and goods such as electronics, fashion items, furniture, 
                household goods, cars and bikes
                </ServicesP>
                <TechUsed>
                    React &emsp; Firebase &emsp; JSON Mock Server &emsp; Socket.io
                    &emsp; Node &emsp; Express
                </TechUsed>
                <BtnWrap>
                <Button 
                        href = 'https://olx-clone-swart.vercel.app' 
                        target = '_blank'
                        primary = "true"
                        dark = "true"
                        smooth = {true}
                        duration = {500}
                        spy = {true}
                        exact = 'true'
                        offset = {-80}>
                            LIVE DEMO <ArrowForward />
                </Button>
                <Button 
                        href = 'https://github.com/kiranjolisa/team-carbon-olx-clone'
                        target = '_blank'
                        primary = "true"
                        dark = "true"
                        smooth = {true}
                        duration = {500}
                        spy = {true}
                        exact = 'true'
                        offset = {-80}>
                            CODE<ArrowForward />
                </Button>
                </BtnWrap>
            </ServicesCard>
            <ServicesCard>
                <ServicesIcon src = {Ketto} alt = "Ketto"/>
                <ServicesH2>
                  Ketto Web App Clone
                </ServicesH2>
                <ServicesP>
                Ketto is an Indian online crowdfunding platform, where any individual/organisation a
                cross the country can raise funds for causes ranging from medical healthcare to 
                disaster relief.
                <br/><br/>
                </ServicesP>
                <TechUsed>
                    React &emsp; Firebase &emsp; JSON Mock Server &emsp; 
                </TechUsed>
                <BtnWrap>
                <Button 
                        href = 'https://ketto-clone-gilt.vercel.app/' 
                        target = '_blank'
                        primary = "true"
                        dark = "true"
                        smooth = {true}
                        duration = {500}
                        spy = {true}
                        exact = 'true'
                        offset = {-80}>
                            LIVE DEMO<ArrowForward />
                </Button>
                <Button 
                        href = 'https://github.com/vinayak-pk/Ketto-clone'  
                        target = '_blank'
                        primary = "true"
                        dark = "true"
                        smooth = {true}
                        duration = {500}
                        spy = {true}
                        exact = 'true'
                        offset = {-80}>
                            CODE<ArrowForward />
                </Button>
                </BtnWrap>
            </ServicesCard>
            <ServicesCard>
                <ServicesIcon src = {Hubspot} alt  = "Hubspot"/>
                <ServicesH2>
                   HubSpot Web App Clone
                </ServicesH2>
                <ServicesP>
                HubSpot is an American developer and marketer of
                 software products for inbound marketing, sales, and customer service.
                 <br/><br/><br/><br/>
                </ServicesP>
                <TechUsed>
                    HTML&emsp; CSS &emsp; JavaScript &emsp; 
                </TechUsed>
                <BtnWrap>
                <Button 
                        href = 'https://hubspot-clone.herokuapp.com/' 
                        target = '_blank'
                        primary = "true"
                        dark = "true"
                        smooth = {true}
                        duration = {500}
                        spy = {true}
                        exact = 'true'
                        offset = {-80}>
                            LIVE DEMO<ArrowForward />
                </Button>
                <Button 
                       href = 'https://github.com/Shubhamsharma585/HubSpot_Clone'
                        target = '_blank'
                        primary = "true"
                        dark = "true"
                        smooth = {true}
                        duration = {500}
                        spy = {true}
                        exact = 'true'
                        offset = {-80}>
                            CODE<ArrowForward />
                </Button>
                </BtnWrap>
            </ServicesCard>
            <ServicesCard>
                <ServicesIcon src = {Chargebee} alt = "Chargebee"/>
                <ServicesH2>
                    ChargeBee Web App Clone
                </ServicesH2>
                <ServicesP>
                develops and publishes a subscription management and recurring billing platform. 
                The Company offers a billing platform that allows subscription based businesses 
                to manage their accounts and recurring billing transactions.
                </ServicesP>
                <TechUsed>
                    HTML&emsp; CSS &emsp; JavaScript &emsp; 
                </TechUsed>
                <BtnWrap>
                <Button 
                        href = 'https://rao-kartik.github.io/chargeebee-clone/' 
                        target = '_blank'
                        primary = "true"
                        dark = "true"
                        smooth = {true}
                        duration = {500}
                        spy = {true}
                        exact = 'true'
                        offset = {-80}>
                            LIVE DEMO<ArrowForward />
                </Button>
                <Button 
                         href = 'https://github.com/rao-kartik/chargeebee-clone' 
                        target = '_blank'
                        primary = "true"
                        dark = "true"
                        smooth = {true}
                        duration = {500}
                        spy = {true}
                        exact = 'true'
                        offset = {-80}>
                            CODE<ArrowForward />
                </Button>
                </BtnWrap>
            </ServicesCard>
        </ServicesWrapper>
    </ServicesContainer>
}

export default Services